// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2lVa-","title":"Header_title__3_L4K","left":"Header_left__Sz5-p","clinicName":"Header_clinicName__1OHH7"};